import type { PolicyViewModel } from '@/api/types/PolicyViewModel';

import { mockRatingHistoryData } from 'src/api/__mocks__/ratingHistory.data';

import { RatingHistory } from 'src/sections/employer-data/shared/rating-history';

const mockViewPolicy = {
  ratingHistory: mockRatingHistoryData.ratingHistory,
};

export function ComboRatingHistory() {
  return (
    <RatingHistory
      width="100%"
      viewPolicy={mockViewPolicy as PolicyViewModel & { ratingHistory?: any[] }}
    />
  );
}
